import { defineMessages } from "react-intl";

export const columnsMessages = defineMessages({
  name: {
    id: "szXISP",
    defaultMessage: "Permission Group Name",
    description: "permission group name",
  },
  members: {
    id: "+a+2ug",
    defaultMessage: "Members",
  },
});

export const messages = defineMessages({
  empty: {
    id: "CXn88q",
    defaultMessage: "No permission groups found",
  },
  deletePermissionGroup: {
    defaultMessage: "Delete permission group",
    id: "nBzIBG",
  },
});
